import React from "react";
import { ReactComponent as Close } from "icons/close-circle-gray.svg";
import Modal from "components/Modal";

type Props = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const ModalReceiveEmail: React.FC<Props> = ({ show, setShow }): JSX.Element => {
  return (
    <Modal
      show={show}
      children={
        <div className="w-full h-60 bg-bt-white p-6 rounded-md">
          <div className="flex flex-row justify-end mb-24">
            <Close
              width={28}
              height={28}
              className="cursor-pointer"
              onClick={() => {
                setShow(false);
                window.location.reload();
              }}
            />
          </div>
          <div className="flex flex-row items-center justify-center">
            <span
              className="font-sora font-light text-2xl text-bt-green"
              style={{
                fontStyle: "normal",
                fontWeight: 700,
              }}
            >
              You will receive an email message soon!
            </span>
          </div>
        </div>
      }
    />
  );
};

export default ModalReceiveEmail;
